// FieldMopsScreen — /mops for field users (27 Sep 2026): the carrier and
// supplier MOP library, read-only, phone-shaped. Managers get the full
// MopsLibraryScreen at the same path (App.tsx branches by role).
import { Link } from "react-router-dom";
import { ArrowLeft, BookOpen } from "lucide-react";
import MopsGuideList from "./MopsGuideList";

export default function FieldMopsScreen() {
  return (
    <div className="p-4 md:p-6 max-w-[760px] mx-auto pb-24">
      <Link to="/" className="inline-flex items-center gap-1.5 text-[12px] text-text-muted hover:text-accent mb-3"><ArrowLeft size={14}/> Home</Link>
      <h1 className="text-[20px] font-semibold text-text flex items-center gap-2 mb-1"><BookOpen size={20} className="text-accent"/> MOPs library</h1>
      <div className="text-[12px] text-text-muted mb-4">The carrier and supplier work instructions — how to install a Telstra cabinet, an NBN MW link, a LeBlanc monopole. Reference only; the job's own MOP is on the job page.</div>
      <MopsGuideList title="Work instructions"/>
    </div>
  );
}
